import { FC } from 'react';
import { Button, Modal } from 'components/core';
import { AskOrderToPrintModalProps, Styled } from './';
import { useI18n } from 'contexts/i18n';

const AskOrderToPrintModal: FC<AskOrderToPrintModalProps> = ({
  onClose,
  onAddToCart,
}) => {
  const i18n = useI18n();
  return (
    <Modal overlaysize="small">
      <Styled.DownloadConfirmationModalBody>
        {i18n['Your item has been successfully downloaded. Would you like to order to print now?']}
      </Styled.DownloadConfirmationModalBody>
      <Styled.DownloadConfirmationModalFooter>
        <Styled.ReviewConfirmationActionButtons>
          <Button onClick={onClose} width="20%" variant="secondary">
            {i18n['Close']}
          </Button>

          <Button onClick={onAddToCart} width="20%" variant="primary">
            {i18n['Yes']}
          </Button>
        </Styled.ReviewConfirmationActionButtons>
      </Styled.DownloadConfirmationModalFooter>
    </Modal>
  );
};

export default AskOrderToPrintModal;
